import { Table } from "@radix-ui/themes";
import _ from "lodash";
import { Skeleton } from "@/components";

interface LoadingRowsProps {
    rows: number;
    columns: number;
}

export default function LoadingRows({ rows, columns }: LoadingRowsProps) {
    return (
        <>
            {_.range(rows).map((row) => (
                <Table.Row key={row}>
                    {_.range(columns).map((column) => (
                        <Table.Cell key={column}>
                            <Skeleton />
                        </Table.Cell>
                    ))}
                </Table.Row>
            ))}
        </>
    );
}
